import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { disableAsset, enableAsset } from '@api/assets';

import { ESnackbarTypes } from '@enums/common';

import {
	ASSET,
	ASSETS_LIST,
	ASSETS_LIST_SHOW_HIDE_ALL,
	ASSETS_LIST_SHOW_HIDE_FILTER,
	CHANGE_STATUS_ASSET,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IChangeAssetStatusRequestDTO {
	id: string;
	showOnMap: boolean;
}

export const useMutateToggleAssetStatus = (id?: string, onSuccessCallback?: () => void) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleChangeViewOnMapAsset,
		isLoading: isChangingAssetStatus,
	} = useMutation<IChangeAssetStatusRequestDTO>({
		mutationKey: [ASSET, CHANGE_STATUS_ASSET, id],
		mutationFn: ({ id, showOnMap }: IChangeAssetStatusRequestDTO) => {
			const toggleStatus = showOnMap ? disableAsset : enableAsset;

			return toggleStatus(id);
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.showedOnMapChanged,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallback) onSuccessCallback();

			return [
				queryClient.invalidateQueries([ASSETS_LIST]),
				queryClient.invalidateQueries([ASSET]),
				queryClient.invalidateQueries([ASSETS_LIST_SHOW_HIDE_FILTER]),
				queryClient.invalidateQueries([ASSETS_LIST_SHOW_HIDE_ALL]),
			];
		},
	});

	return {
		handleChangeAssetStatus: handleChangeViewOnMapAsset,
		isChangingAssetStatus,
	};
};
